/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface UpdateMessageDto
 */
export interface UpdateMessageDto {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMessageDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMessageDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMessageDto
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMessageDto
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMessageDto
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMessageDto
     */
    adminNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMessageDto
     */
    status?: UpdateMessageDtoStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateMessageDtoStatusEnum {
    Pending = 'Pending',
    Read = 'Read',
    Resolved = 'Resolved',
    Archived = 'Archived'
}

